// src/lib/email/contact-utils.ts
import { supabase } from '@/lib/supabase';

export interface ContactDetails {
  firstName: string;
  lastName: string;
  companyName?: string;
  occupation?: string;
  email?: string;
  phone?: string;
}

export async function getContactIdByEmail(email: string): Promise<string | null> {
  try {
    const { data, error } = await supabase
      .from('contacts')
      .select('id, email_address!inner(email)')
      .eq('email_address.email', email)
      .single();

    if (error || !data) return null;
    return data.id;
  } catch {
    return null;
  }
}

export async function getContactByEmail(email: string): Promise<ContactDetails | null> {
  try {
    const { data, error } = await supabase
      .from('contacts')
      .select(`
        first_name,
        last_name,
        company_name,
        job_title,
        email_address!inner (
          email
        ),
        phone_numbers (
          phone_number,
          "isPrimary"
        )
      `)
      .eq('email_address.email', email)
      .single();

    if (error || !data) return null;

    return {
      firstName: data.first_name,
      lastName: data.last_name,
      companyName: data.company_name,
      occupation: data.job_title,
            email: data.email_address?.[0]?.email,
      phone: data.phone_numbers?.find(p => p.isPrimary)?.phone_number
    };
  } catch (error) {
    console.error('Error fetching contact:', error);
    return null;
  }
}
